import { IsString, IsNotEmpty } from 'class-validator';

export class GoogleTokenDto {
  @IsString()
  credential: string;
}
export class LoginByCardDto {
  @IsNotEmpty()
  @IsString()
  cardNumber: string;
}

export class EmailVerificationDto {
  @IsString()
  @IsNotEmpty()
  token: string;

  @IsString()
  @IsNotEmpty()
  id: string;
}
